import varAxios from "../../../Comman/axios";
import { GetPendingForApprovalListUrl, ApprovedUserProfileEditUrl,GetRegionListUrl } 
     from "../../../Comman/apiEndPoints"

export const FETCH_PENDING_EDITPROFILE_REQUEST = "(fetch) FETCH PENDING EDITPROFILE REQUEST";
export const FETCH_PENDING_EDITPROFILE_SUCCESS = "(fetch) FETCH PENDING EDITPROFILE SUCCESS";
export const FETCH_PENDING_EDITPROFILE_ERROR = "(fetch) FETCH PENDING EDITPROFILE ERROR";

export const UPDATE_PENDING_EDITPROFILE_REQUEST = "(update) UPDATE PENDING EDITPROFILE REQUEST";
export const UPDATE_PENDING_EDITPROFILE_SUCCESS = "(update) UPDATE PENDING EDITPROFILE SUCCESS";
export const UPDATE_PENDING_EDITPROFILE_ERROR = "(update) UPDATE PENDING EDITPROFILE ERROR";
export const Fetch_All_Region_Data1 = "Fetch_All_Region_Data1";

export function fetchHeartRunnerDetail(RegionId,dispatch) {
   

    return (dispatch) => {
        dispatch(fetchHeartRunnerDetailRequest(true));

        return varAxios.post(GetPendingForApprovalListUrl,RegionId,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                dispatch(
                    fetchHeartRunnerDetailSuccess(false, response.data.pendingList,response.data.statusCode) 
                );
            })
            .catch((error) => {
                
                if(error.response.data.statusCode==401){
                    
                    dispatch(
                        fetchHeartRunnerDetail( RegionId,dispatch)
                    );
                }
            })
    }
}

export function fetchHeartRunnerDetailRequest(isLoading) {
    return {
        type: FETCH_PENDING_EDITPROFILE_REQUEST,
        isLoading
    }
}

export function fetchHeartRunnerDetailSuccess(isLoading, pendingEditProfileList,statusCode) {
    return {
        type: FETCH_PENDING_EDITPROFILE_SUCCESS,
        isLoading,
        pendingEditProfileList,
        statusCode
    }
}

export function approveHeartRunner(isLoading, deviceList,regionId, dispatch) {
    var approveHeartRunnerList = [];
    approveHeartRunnerList = deviceList;
 
    return (dispatch) => {
        dispatch(updateDeviceDetailRequest(true));

        return varAxios.post(ApprovedUserProfileEditUrl, deviceList,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
               
                /* dispatch(
                    updateDeviceDetailSuccess(false, 
                        response.data.pendingList, 
                        response.data.errorMessage,
                        response.data.statusCode
                        )
                ); */
               this.fetchHeartRunnerDetail({RegionId:regionId},dispatch)
            })
            .catch((error) => {
                if(error.response.data.statusCode==401){
                    
                    dispatch(
                        approveHeartRunner(isLoading, deviceList,regionId, dispatch)
                    );
                }
            })
    }
}

export function rejectHeartRunner(isLoading, deviceList,regionId, dispatch) {
    var rejectHeartRunnerList = [];    
    rejectHeartRunnerList.push(deviceList)
 
    return (dispatch) => {
        dispatch(updateDeviceDetailRequest(true));

        return varAxios.post(ApprovedUserProfileEditUrl, deviceList,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                
                /* dispatch(
                    updateDeviceDetailSuccess(false, 
                        response.data.pendingList, 
                        response.data.errorMessage,
                        response.data.statusCode,

                        )
                ); */
                 this.fetchHeartRunnerDetail({RegionId:regionId},dispatch)
            })
            .catch((error) => {
                if(error.response.data.statusCode==401){
                    
                    dispatch(
                        rejectHeartRunner(isLoading, deviceList,regionId, dispatch)
                    );
                }
            })
    }
}

export function updateDeviceDetailRequest(isLoading) {
    return {
        type: UPDATE_PENDING_EDITPROFILE_REQUEST,
        isLoading
    }
}

export function updateDeviceDetailSuccess(isLoading, pendingEditProfileList, messageLabel,statusCode) {
    
    return {
        type: UPDATE_PENDING_EDITPROFILE_SUCCESS,
        isLoading,
        pendingEditProfileList,
        messageLabel,
        statusCode
    }
}
  export function getAllRegionSettings() {
     let requestPayload={
    UserId:sessionStorage.getItem('SuperAdminUserID')
  }
    return(dispatch) =>{
       return varAxios.post(GetRegionListUrl,requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
       .then(response => {
       
       
        this.fetchHeartRunnerDetail({RegionId:response.data.regionList[0].ID})
          dispatch(
            fetchAllRegionData({
              errorCode : response.data.errorCode,
              statusCode : response.data.statusCode,
              regionList : response.data.regionList
             }));
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchAllRegionData({errorCode, statusCode, regionList}) {
  return {
    type : Fetch_All_Region_Data1,
    errorCode,
    statusCode,
    regionList
  }
}
